import { EXPERIENCE_DOMAIN_CONFIG, customTrackingConfig } from '../../constants';

export const appendTrackingScript = (companyId: number): void => {
  if (!document.querySelector('#custom-tracking')) {
    const host = window.location.hostname as EXPERIENCE_DOMAIN_CONFIG;
    let isCompanyEnabled = false;
    const customTracking = customTrackingConfig[host];
    if (typeof customTracking === 'object') isCompanyEnabled = customTracking.companyIds.includes(companyId);

    if (isCompanyEnabled) {
      const div = document.createElement('div');
      div.setAttribute('id', 'custom-tracking');

      const axel = Math.random();
      const a = axel * 10000000000000;
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.width = '1';
      iframe.height = '1';
      iframe.src = `https://10289793.fls.doubleclick.net/activityi;src=10289793;type=caree0;cat=caree00;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=\${GDPR};gdpr_consent=\${GDPR_CONSENT_755};ord=${a}?`; // eslint-disable-line

      div.appendChild(iframe);
      document.body.appendChild(div);
    }
  }
};
